import { mapActions, mapState } from "vuex";
import DatesSelectedDialog from "@/components/action-plans/components/selectedDatesField/index.vue";
import QuestionsSelectedDialog from "../components/selectedQuestionsDialog";
import { showError, showSnackBar } from "@/helpers/globalHelpers";
import moment from "moment";

export default {
  name: "CreateActionPlan",

  data: () => ({
    loadingSend: false,
    searchQuestion: "",
    isValidForm: null,
    selectedDates: [],
    selectedQuestions: [],
    isLoadingManagements: false,
    isLoadingValidCostCenters: false,
    validCostCenters: [],
    requiredRule: [(v) => !!v || "Campo requerido"],
    formAP: {
      company_id: parseInt(localStorage.getItem("company_id")),
      service_id: null,
      description: "",
      responsible: null,
      recipients: null,
    },
    questionsHeader: [
      { text: "Factores", sortable: false, value: "factor.name" },
      { text: "Subfactores", sortable: false, value: "sub_factor.name" },
      { text: "Preguntas", sortable: false, value: "description" },
      { text: "", sortable: false, value: "actions", align: "right" },
    ],
    // Usuario Responsable
    searchTextResponsible: '',
    localSearchResponsibles: [],
    loadingSearchResponsible: false,
    debouncedSearchResponsible: null,

    // Usuario a Notificar
    localSearchUsers: [],
    loadingSearchUser: false,
    debouncedSearchUser: null,
  }),

  async created() {
    this.debouncedSearchResponsible = this.debounce(this.fetchSearchResponsible, 500);
    this.debouncedSearchUser = this.debounce(this.fetchSearchUser, 500);
    await Promise.all([
    this.loadManagements(),
    this.getPlanType(),
  ]);
  await this.loadValidCostCenters();
  },

  computed: {
    ...mapState("plan_type", ["planType"]),
    ...mapState("auth", ["user"]),
    ...mapState("security", [
      "costCentersUser",
      "costCentersUserRole",
      //  "costCenters"
    ]),

    profiles() {
            const companies = this.$store.state.auth.user?.companies || [];
            const profiles = [];
            if (Array.isArray(companies)) {
                companies.forEach((company) => {
                    company.profiles.forEach((profile) => {
                        profiles.push(profile.role);
                    });
                });
            }
            return profiles || [];
        },

        isAuthorized() {
            const planTypeProfiles = this.planType?.profiles?.map(
                (profile) => profile.profile.id
            );
            return this.profiles?.some((profile) =>
                planTypeProfiles?.includes(profile.id)
            );
        },
        
    breadcrumbs() {
      return [
        {
          text: "Inicio",
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "Dashboard",
          },
        },
        {
          text: "Planes de acción",
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "ListEvidenceActionPlanDinamic",
            params:{planTypeId: this.$route.params.planTypeId}
          },
        },
        {
          text: "Crear plan de acción",
          link: true,
          exact: true,
          disabled: true,
        },
      ];
    },
  },

  methods: {
    ...mapActions("plan_type", ["getPlanTypeByIdV2", "cleanPlanTypeId"]),
    ...mapActions("security", [
      "getUsersActiveDebounced",
      "getCostCenterUser",
      "getCostCenterUserRole",
      //  "getCostCenter"
    ]),
    ...mapActions("action_plan", ["createActionPlan"]),

    async getPlanType() {
            this.isLoadingPlanType = true;
            const { planTypeId } = this.$route.params;
            // const { error } = await this.getPlantypeById(planTypeId);
            const { error } = await this.getPlanTypeByIdV2(
                {
                    id: planTypeId,
                    onlyEntity: false,
                    relations: ['profiles', 'custom_fields', 'groupings', 'fields'],
                    populate: true
                })
            if (error) showError(error);

            if (!this.isAuthorized) {
                this.$router.push({ name: "NotAuthorized" });
            }

            this.initializeDynamicFields();

            this.isLoadingPlanType = false;
        },

    initializeDynamicFields() {
            if (!this.planType || !this.planType.fields) return;

            this.dynamicFields = this.planType.fields.map((field) => {
                let parsedValues = [];

                if (field.field_type === "LISTA DESPLEGABLE" && field.values) {
                    try {
                        parsedValues = JSON.parse(field.values);
                    } catch (error) {
                        showSnackBar("Error interno, contactarse con el administrador", "error");
                    }
                }

                return {
                    id: field.id,
                    field_name: field.field_name,
                    type: field.field_type,
                    description: field.description || "",
                    listValues: parsedValues
                };
            });
        },

    loadManagements: async function () {
      this.isLoadingManagements = true;
      await this.getCostCenterUserRole({ user_id: this.user.id });
      this.isLoadingManagements = false;
    },

    loadValidCostCenters() {
      this.isLoadingValidCostCenters = true;
      const planTypeProfiles = this.planType?.profiles?.map(p => p.profile.id) || [];
      const userProfileIds = this.profiles.map(p => p.id);

      const matchingRoleIds = planTypeProfiles.filter(roleId =>
        userProfileIds.includes(roleId)
      );

      const validRoles = this.costCentersUserRole.filter(r =>
        matchingRoleIds.includes(r.role_id)
      );
      this.validCostCenters = Array.from(
        new Map(
          validRoles
            .flatMap(r => r.costCenters)
            .map(cc => [cc.id, cc])
        ).values()
      );
      this.isLoadingValidCostCenters = false;
  },

    removeQuestion: function (questionId) {
      const index = this.selectedQuestions.findIndex(
        (e) => e?.id === questionId
      );
      if (index > -1) this.selectedQuestions.splice(index, 1);
    },

    validationForm: function () {
      const formCompleted = this.$refs.form.validate();
      const periodCompleted = this.selectedDates.length > 0;
      const questionCompleted = this.selectedQuestions.length > 0;

      if (!formCompleted) {
        showSnackBar("Completar el formulario", "warning");
        return false;
      }

      if (!periodCompleted) {
        showSnackBar("Completar el período", "warning");
        return false;
      }

      if (!questionCompleted) {
        showSnackBar("Seleccionar las preguntas", "warning");
        return false;
      }

      if (formCompleted && periodCompleted && questionCompleted) {
        this.saveActionPlan();
      }
    },

    saveActionPlan: async function () {
      this.loadingSend = true;
      let data = {
        ...this.formAP,
        plan_type_id: this.planType.id,
        questions: [],
        periodicity: [],
      };

      this.selectedDates.forEach((date) => {
        data.periodicity.push({
          period_date: moment(date).toISOString(),
        });
      });

      this.selectedQuestions.forEach((question) => {
        data.questions.push(question?.id);
      });

      const { ok, error } = await this.createActionPlan(data);
      if (ok) {
        this.$swal.fire({
          title: "¡El plan de acción fue creado con éxito!",
          text: "En un momento te enviaremos la aprobación por correo para que puedas subir tu evidencia, gracias",
          icon: "success",
          confirmButtonColor: "#0039a6",
          confirmButtonText: "Ok",
        });
        this.$router.push({ name: "ListActionPlanEvidences", planTypeId: this.planType.id, });
      } else {
        let errorMsm = error?.data?.message;
        errorMsm = Array.isArray(errorMsm) ? errorMsm.join(" <br> ") : errorMsm;
        showSnackBar(errorMsm, "error");
      }
      this.loadingSend = false;
    },

    debounce(func, delay) {
      let timer;
      return function (...args) {
          clearTimeout(timer);
          timer = setTimeout(() => func?.apply(this, args), delay);
      };
    },

    async fetchSearchResponsible(query) {
        if (!query || query.length < 2) return;
        this.loadingSearchResponsible = true;
        try {
            const { ok, response } = await this.getUsersActiveDebounced({
                search: query.toUpperCase(),
            });
            if (ok) {
                this.localSearchResponsibles = response.data.map((user) => ({
                    ...user,
                    fullName: user.fullName?.toUpperCase() || '',
                }));
            }
        } catch (err) {

        } finally {
            this.loadingSearchResponsible = false;
        }
    },

    async fetchSearchUser(query) {
      if (!query || query.length < 2) return;
      this.loadingSearchUser = true;
      try {
          const { ok, response } = await this.getUsersActiveDebounced({
            search: query.toUpperCase(),
          });
          if (ok) {
            const mergedUsers = [
              ...this.localSearchUsers?.filter(user => (this.formAP?.recipients || []).includes(user.id)),
              ...response.data.map((user) => ({
                ...user,
                fullName: user.fullName?.toUpperCase() || '',
              }))
            ];
            this.localSearchUsers = [...mergedUsers];
          }
      } catch (err) {

      } finally {
          this.loadingSearchUser = false;
      }
    },
  },

  components: {
    DatesSelectedDialog,
    QuestionsSelectedDialog,
  },
};
